module.exports = "/images/o-logo-color.svg?ba177ae82a808c9824d80db3e8d5461b";